import ListAgreement from '../general/agreements/list-agreement';

export enum AgreementType {
  USER = 'USER',
  ORGANIZATION = 'ORG',
}

export enum ContentType {
  FILE = 'FILE',
  LINK = 'LINK',
  SURVEY = 'SURVEY',
}

export enum AgreementUserTitleKeys {
  TERMS_AND_CONDITIONS = 'agreement-user-title-key-terms-and-conditions',
  CUSTOMER_SURVEY = 'agreement-user-title-key-customer-survey',
  LEGAL_AGREEMENT = 'agreement-user-title-key-legal-agreement',
}

export enum AgreementUserAgreeKeys {
  ACCEPT = 'agreement-user-agree-key-accept',
  ACCEPT_LEGAL_AGREEMENT = 'agreement-user-agree-key-accept-legal-agreement',
}

export enum AgreementUserInstructionsKeys {
  CONFIRM_ACCEPT = 'agreement-user-instructions-key-confirm-accept',
  LEGAL_AGREEMENT = 'agreement-user-instructions-key-legal-agreement',
}

export enum AgreementOrganizationTitleKeys {
  TERMS_AND_CONDITIONS = 'agreement-organization-title-key-terms-and-conditions',
}

export enum AgreementOrganizationAgreeKeys {
  ACCEPT = 'agreement-organization-agree-key-accept',
}

export enum AgreementOrganizationInstructionsKeys {
  CONFIRM_ACCEPT = 'agreement-organization-instructions-key-confirm-accept',
}

export const getAgreementTitleKeyValues = (agreementType: AgreementType) => {
  if (agreementType === AgreementType.ORGANIZATION) {
    return Object.values(AgreementOrganizationTitleKeys);
  }
  return Object.values(AgreementUserTitleKeys);
};

export const getAgreementAgreeKeyValues = (agreementType: AgreementType) => {
  if (agreementType === AgreementType.ORGANIZATION) {
    return Object.values(AgreementOrganizationAgreeKeys);
  }
  return Object.values(AgreementUserAgreeKeys);
};

export const getAgreementInstructionsKeyValues = (agreementType: AgreementType) => {
  if (agreementType === AgreementType.ORGANIZATION) {
    return Object.values(AgreementOrganizationInstructionsKeys);
  }
  return Object.values(AgreementUserInstructionsKeys);
};

export const updateAgreementOrders = (agreements: ListAgreement[], oldAgreement: ListAgreement) => {
  agreements
    .filter(
      (a) =>
        a.agreementType === oldAgreement.agreementType && a.enabled && a.order > oldAgreement.order,
    )
    .forEach((a) => {
      a.order -= 1;
    });
};

export const getChangesInstructionsKey = (instructionsKey: string): string => {
  return `${instructionsKey}-changes`;
};
